import { Component, Input } from 'ng-metadata/core';

import './social-echo.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentSocialEcho
 * @module mw.components.contentDocuments
 * @param {number} [twitter-shares] - The amount of shares for twitter
 * @param {number} [facebook-shares] - The amount of shares for facebook
 * @description
 * `mw-content-document-social-echo` is a component responsible for displaying a document's social echo stats
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-social-echo twitter-shares="10" facebook-shares="15"> <mw-content-document-social-echo>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-social-echo',
    template: `
        <mw-content-document-tray-loader ng-if="$ctrl.socialEchoLoading"></mw-content-document-tray-loader>
        <div ng-if="!$ctrl.socialEchoLoading" class="mw-content-document-social-echo">
            <div>
                <ul class="mw-content-document-social-echo__list">
                    <li class="mw-content-document-social-echo__list-item">
                        <md-icon md-svg-icon="meltwater:twitter" class="small-icon-12 mw-content-document-social-echo__twitter-icon"></md-icon>
                        <span class="mw-content-document-social-echo__count">{{::$ctrl.twitterShares}}</span>
                    </li>
                    <li class="mw-content-document-social-echo__list-item">
                        <md-icon md-svg-icon="meltwater:facebook" class="small-icon-12 mw-content-document-social-echo__facebook-icon"></md-icon>
                        <span class="mw-content-document-social-echo__count">{{::$ctrl.facebookShares}}</span>
                    </li>
                </ul>
            </div>
        </div>
    `
})

export class SocialEchoComponent {
    @Input('<') twitterShares: number = 0;
    @Input('<') facebookShares: number = 0;
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/social-echo/social-echo.component.ts